import { createContext, useContext, useEffect, useMemo } from "react";
import { useGetSkuBySqft } from "../hooks";
import {
  DISCOUNT_SKUS,
  MATTERPORT_APPT_SKUS,
  PREMIUM_VIDEO_SKUS,
  SIGN_DISCOUNT_SKUS,
  STANDARD_VIDEO_SKUS,
  TWILIGHT_VIDEO_SKUS,
} from "../helpers/constants";
import { useFormContext } from "react-hook-form";
import { useBundleContext } from "./BundlesContext";

const ProductWatcherContext = createContext();

const useDiscounts = () => {
  const { selectedBundle } = useBundleContext();
  const { getValues, setValue, watch } = useFormContext();
  const all_products = watch();
  const [sign_product, ...sign_discount_skus] = watch([
    "8001",
    ...SIGN_DISCOUNT_SKUS,
  ]);
  const hasSignProducts =
    sign_product && sign_discount_skus.filter(Boolean).length >= 3;

  useEffect(() => {
    setValue("8002", hasSignProducts);
  }, [hasSignProducts, setValue]);

  useEffect(() => {
    DISCOUNT_SKUS.forEach(({ product_skus, discount_sku, noBundle = true }) => {
      const hasProducts =
        (!noBundle || !selectedBundle) &&
        product_skus
          .map((options) =>
            options.map((skus) => getValues(skus).some(Boolean)).every(Boolean)
          )
          .some(Boolean);
      const currentValue = getValues(discount_sku);
      if (currentValue !== hasProducts) {
        setValue(discount_sku, hasProducts);
      }
    });
  }, [all_products, getValues, setValue, selectedBundle]);
};

export const ProductWatcherProvider = (props) => {
  const standard_video_sku = useGetSkuBySqft(STANDARD_VIDEO_SKUS);
  const premium_video_sku = useGetSkuBySqft(PREMIUM_VIDEO_SKUS);
  const twilight_video_sku = useGetSkuBySqft(TWILIGHT_VIDEO_SKUS);
  const matterport_sku = useGetSkuBySqft(MATTERPORT_APPT_SKUS);
  useDiscounts();
  const values = useMemo(
    () => ({
      standard_video_sku,
      premium_video_sku,
      matterport_sku,
      twilight_video_sku,
    }),
    [standard_video_sku, premium_video_sku, matterport_sku, twilight_video_sku]
  );
  return <ProductWatcherContext.Provider value={values} {...props} />;
};

export const useProductWatcher = () => useContext(ProductWatcherContext);
